import React from 'react';
import PropTypes from 'prop-types';

import { renderableType } from '../proptypes/prop-types';
import { buildClassNames, buildClassNameModifiers } from '../util/utils';
import './panel.scss';

const blockBaseClassName = 'panel';
const containerClassName = 'panel__container';

export const Panel = ({
                 children,
                 className,
                 block,
                 hidden,
                 floating,
                 ...other
               }) => {
  if (hidden) {
    return null;
  }

  const blockClassNames = buildClassNames(
    className,
    buildClassNameModifiers(blockBaseClassName, { block }, { floating }),
    blockBaseClassName,
  );
  const containerClassNames = buildClassNames(
    buildClassNameModifiers(blockBaseClassName, { floating }),
    containerClassName,
  );

  if (floating) {
    return (
      <div className={containerClassNames} {...other}>
        <div className={blockClassNames}>
          {children}
        </div>
      </div>
    );
  }
  return (
    <div className={blockClassNames} {...other}>{children}</div>
  );
};


Panel.propTypes = {
  /** @ignore */
  children: renderableType,
  /** @ignore */
  className: PropTypes.string,
  /** Indicates whether the panel will be rendered in block mode */
  block: PropTypes.bool,
  /** Indicates whether the panel will be rendered in floating mode */
  floating: PropTypes.bool,
  /** Indicates whether the panel is hidden from view */
  hidden: PropTypes.bool,
};

Panel.defaultProps = {
  block: false,
  floating: false,
  hidden: false,
};